import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import 'dayjs/locale/es';

dayjs.extend(relativeTime);
dayjs.locale('es');

/**
 * Pipe que transforma una fecha en una cadena de tiempo relativo en español
 * (por ejemplo, "hace 5 minutos") usando dayjs con el plugin relativeTime.
 */
@Pipe({
  name: 'ago'
})
export class AgoPipe implements PipeTransform {
  /**
   * Convierte la fecha recibida en una expresión de tiempo relativo respecto al momento actual.
   * @param value - Fecha a transformar, como `string` o `Date`.
   * @returns El tiempo relativo en español, o una cadena vacía si `value` es nulo.
   */
  transform(value: string | Date): string {
    if (!value) return '';
    return dayjs(value).fromNow();
  }
}
